import { eventManager } from "@foretagsplatsen/yaem";
import jQuery from "jquery";

/*
 * Unique id number used across request events.
 */

let id = 0;

function nextId() {
	id = id + 1;
	return id;
}

/*
 * A `syncEvent' object is propagated into event objects, triggered before and
 * after performing ajax requests.
 *
 * Each `syncEvent' object represents an unique request made by the `sync' object,
 * identified by an unique id number.
 */

function syncEvent(url) {
	return {
		url,
		id: nextId(),
	};
}

/*
 * The `sync' object is responsible for handling all ajax requests.
 * Before making a request, it will fire a 'request' event with a `syncEvent' argument.
 * It internally uses jQuery.
 */
const sync = (function () {
	const that = {};

	const defaultMethod = "get";
	const defaultContentType = "application/json;charset=UTF-8";

	that.withLoading = function (callback) {
		const event = syncEvent();
		eventManager.at("sync").trigger("loading", event);
		callback();
		eventManager.at("sync").trigger("loaded", event);
	};

	that.ajax = function (method, url, spec) {
		spec ||= {};
		const event = syncEvent(url);
		eventManager.at("sync").trigger("loading", event);

		return jQuery.ajax(url, {
			type: method || defaultMethod,
			contentType: spec.contentType || defaultContentType,
			data: spec.data,
			success: function (data) {
				if (!spec.success) {
					return;
				}
				spec.success(data);
			},
			error: function (jqXHR) {
				if (sessionExpired(jqXHR)) {
					eventManager.at("sync").trigger("session-expired");
					return;
				}
				if (spec.error) {
					spec.error(jqXHR);
				}
			},
			complete: function () {
				eventManager.at("sync").trigger("loaded", event);
			},
		});
	};

	that.get = function (url, spec) {
		return that.ajax("get", url, spec);
	};

	that.put = function (url, spec) {
		return that.ajax("put", url, spec);
	};

	that.post = function (url, spec) {
		return that.ajax("post", url, spec);
	};

	that.remove = function (url, spec) {
		return that.ajax("delete", url, spec);
	};

	function sessionExpired(xhr) {
		// 440 Login Timeout
		// https://en.wikipedia.org/wiki/List_of_HTTP_status_codes
		return xhr.status === 440;
	}

	return that;
})();

export default sync;
